import { Injectable } from '@angular/core';

@Injectable()
export class MeterVerificationStateService {
    private _status: boolean | null = null;
    private STORAGE_KEY = 'isMetersVerified';

    setStatus(value: boolean | null) {
        this._status = value;
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(value));
    }

    loadFromStorage() {
        const value = localStorage.getItem(this.STORAGE_KEY);
        this._status = value !== null ? JSON.parse(value) : null;
    }

    get status(): boolean | null {
        if (this._status === null) {
            const value = localStorage.getItem(this.STORAGE_KEY);
            this._status = value !== null ? JSON.parse(value) : null;
        }
        return this._status;
    }

    clear() {
        this._status = null;
        localStorage.removeItem(this.STORAGE_KEY);
    }
}
